import { Appointment, FollowUpAppointmentDto } from "@myapp/contract";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { appointmentKeys } from "../appointment.keys";
import { scheduleKeys } from "../../../schedule/api/schedule.keys";
import { appointmentApi } from "../service";
import { auditLogKeys } from "../../../audit-log";

export function useFollowUpAppointment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, dto, workOrderId }: { id: number; dto: FollowUpAppointmentDto; workOrderId?: string }) => {
      const { data } = await appointmentApi.followUp(id, dto);
      return { appointment: data as Appointment, workOrderId };
    },
    onSettled: (_data, _err, vars) => {
      queryClient.invalidateQueries({ queryKey: appointmentKeys.all });
      // See `useCompleteAppointment` — the calendar's copy of this Termin lives under scheduleKeys.
      queryClient.invalidateQueries({ queryKey: scheduleKeys.all });
      if (vars?.workOrderId) {
        queryClient.invalidateQueries({ queryKey: auditLogKeys.byWorkOrder(vars.workOrderId) });
      }
    },
  });
}
